import { render } from "./orderinfo.vue?vue&type=template&id=674dd6c9&scoped=true"
import script from "./orderinfo.vue?vue&type=script&lang=js"
export * from "./orderinfo.vue?vue&type=script&lang=js"

import "./orderinfo.vue?vue&type=style&index=0&id=674dd6c9&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674dd6c9"]])

export default __exports__